export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [strDt, endDt];
	},
	eqipKndDisabled_({ popupData }) {
		return popupData.eqipKndCd === 'S';
	}
};
